import React from "react";


const StatCard = ({
  icon,
  label = "Total Clients",
  value = "30",
  valueColor = "#000000"
}) => {
  return (
    <div className="col-12  lg:col-4">
      <div className={`stat-card shadow ${!icon ? "no-icon" : ""}`}>
        
        {/* Icon */}
        {icon && (
          <div className="icon-card">
            {icon}
          </div>
        )}

        {/* Text */}
        <div className="text-content">
          <span className="label-text item-dialog-header">
            {label}
          </span>

          <span
            className="value-text"
            style={{ color: valueColor }}
          >
            {value}
          </span>
        </div>

      </div>
    </div>
  );
};

export default StatCard;
